// @flow
/** @jsx h */
import { h, Fragment } from 'preact';
import {
  useErrorModalContext,
  useErrorModalContextDispatch,
} from '../../storeProviders/errorModalStore';
import ErrorModal from '../errorModal';
import CheckoutErrorModal from '../checkoutWidget/CheckoutErrorModal';

const CommonErrorModal = (props) => {
  const errorModalState = useErrorModalContext();
  const errorModalDispatch = useErrorModalContextDispatch();

  const handleClose = () => {
    if (errorModalState.handleClose) errorModalState.handleClose();
    errorModalDispatch({ type: 'MODAL/CLOSE' });
  };
  const handleOnRetryClick = () => {
    if (errorModalState.onRetryClick) errorModalState.onRetryClick();
    errorModalDispatch({ type: 'MODAL/CLOSE' });
  };

  const getErrorModal = (template, props) => {
    switch (template) {
      case 'checkoutWidget':
        return <CheckoutErrorModal {...props} />;
      default:
        <ErrorModal {...props} />;
    }
  };

  return (
    <Fragment>
      {errorModalState.title &&
        getErrorModal(errorModalState.template, {
          ...errorModalState,
          handleClose,
          handleOnRetryClick,
        })}
    </Fragment>
  );
};
export default CommonErrorModal;



// WEBPACK FOOTER //
// ./components/commonErrorModal/index.js